export type EventListener<EventData> = (data: EventData) => void

export class EventEmitter<EventData> {
    listeners: { [id: number]: EventListener<EventData> } = {}

    private nextId = 0

    emit(data: EventData) {
        for (const listener of Object.values(this.listeners)) {
            listener(data)
        }
    }

    listen(listener: EventListener<EventData>) {
        const id = this.nextId++
        this.listeners[id] = listener
        const unsubscribe = () => {
            delete this.listeners[id]
        }
        return unsubscribe
    }
}
